import { Component, OnDestroy, OnInit } from '@angular/core';

import { Subscription } from 'rxjs';

import { MessageService } from 'primeng/components/common/messageservice';

import { Configs } from '../../base/vo/configs';
import { ConfigsChatbot } from '../../base/vo/configs-chatbot';
import { ConfigsEmail } from '../../base/vo/configs-email';
import { ConfigsSiebel } from '../../base/vo/configs-siebel';
import { ConfigsTokenGTO } from '../../base/vo/configs-token-gto';
import { AdminConfigsService } from './admin-configs.service';


@Component({
  selector: 'app-admin-configs',
  templateUrl: './admin-configs.component.html',
  styleUrls: ['./admin-configs.component.scss']
})

export class AdminConfigsComponent implements OnInit, OnDestroy {

  loading = false;
  configs: Configs = new Configs();
  siebelConfigs: ConfigsSiebel = new ConfigsSiebel();
  emailConfigs: ConfigsEmail = new ConfigsEmail();
  chatbotConfigs: ConfigsChatbot = new ConfigsChatbot();
  tokenGTOConfigs: ConfigsTokenGTO = new ConfigsTokenGTO();
  listErrors: any;
  menuSelected = 'geral';

  /*Mensagens*/
  msgTitulo = 'Configurações';
  msgSucesso = 'As configurações foram salvas sucesso!';

  subs: Subscription[] = [];


  constructor(private adminConfigsService: AdminConfigsService,
    public messageService: MessageService) { }

  public ngOnInit() {
    this.buscarConfigs();
  }

  ngOnDestroy() {
    this.subs.forEach((subscription) => subscription.unsubscribe());
  }

  buscarConfigs() {
    this.loading = true;
    this.subs.push(
      this.adminConfigsService.buscarConfigs().subscribe(
        response => {
          this.loading = false;
          this.configs = response.data;
        },
        errorResponse => {
          this.loading = false;
          this.messageService.add({ severity: 'error', summary: 'Erro', detail: errorResponse.error.mensagem });
        }
      )
    );
  }

  salvar() {
    this.loading = true;
    this.subs.push(
      this.adminConfigsService.salvarConfigs(this.configs).subscribe(
        response => {
          this.loading = false;
          this.messageService.add({ severity: 'success', summary: this.msgTitulo, detail: this.msgSucesso });
        },
        errorResponse => {
          this.loading = false;
          this.listErrors = errorResponse.error.errors;
          this.messageService.add({ severity: 'error', summary: 'Erro ao salvar', detail: errorResponse.error.mensagem });
        }
      )
    );
  }

  getMsgErro(campo) {
    if (this.listErrors && campo) {
      for (let index = 0; index < this.listErrors.length; index++) {
        if (this.listErrors[index].field === campo) {
          return this.listErrors[index].message;
        }
      }
    }

    return null;
  }

  selectMenu(menu) {
    if (this.menuSelected === menu) { return; }

    this.listErrors = null;
    this.menuSelected = menu;
    if (this.menuSelected === 'geral') {
      this.buscarConfigs();
    } else if (this.menuSelected === 'siebel') {
      this.buscarSiebelConfigs();
    } else if (this.menuSelected === 'email') {
      this.buscarEmailConfigs();
    } else if (this.menuSelected === 'chatbot') {
      this.buscarChatbotConfigs();
    } else if (this.menuSelected === 'tokenGTO') {
      this.buscarTokenGTOConfigs();
    }
  }

  isMenuSelected(menu) {
    if (this.menuSelected === menu) {
      return true;
    } else {
      return false;
    }
  }

  buscarSiebelConfigs() {
    this.loading = true;
    this.subs.push(
      this.adminConfigsService.buscarSiebelConfigs().subscribe(
        response => {
          this.loading = false;
          this.siebelConfigs = response.data;
        },
        errorResponse => {
          this.loading = false;
          this.messageService.add({ severity: 'error', summary: 'Erro', detail: errorResponse.error.mensagem });
        }
      )
    );
  }

  salvarSiebel() {
    this.loading = true;
    this.subs.push(
      this.adminConfigsService.salvarSiebelConfigs(this.siebelConfigs).subscribe(
        response => {
          this.loading = false;
          this.messageService.add({ severity: 'success', summary: this.msgTitulo, detail: this.msgSucesso });
        },
        errorResponse => {
          this.loading = false;
          this.listErrors = errorResponse.error.errors;
          this.messageService.add({ severity: 'error', summary: 'Erro', detail: errorResponse.error.mensagem });
        }
      )
    )
  }

  buscarEmailConfigs() {
    this.loading = true;
    this.subs.push(
      this.adminConfigsService.buscarEmailConfigs().subscribe(
        response => {
          this.loading = false;
          this.emailConfigs = response.data;
        },
        errorResponse => {
          this.loading = false;
          this.messageService.add({ severity: 'error', summary: 'Erro', detail: errorResponse.error.mensagem });
        }
      )
    );
  }

  salvarEmail() {
    this.loading = true;
    this.subs.push(
      this.adminConfigsService.salvarEmailConfigs(this.emailConfigs).subscribe(
        response => {
          this.loading = false;
          this.messageService.add({ severity: 'success', summary: this.msgTitulo, detail: this.msgSucesso });
        },
        errorResponse => {
          this.loading = false;
          this.listErrors = errorResponse.error.errors;
          this.messageService.add({ severity: 'error', summary: 'Erro', detail: errorResponse.error.mensagem });
        }
      )
    );
  }

  buscarChatbotConfigs() {
    this.loading = true;
    this.subs.push(
      this.adminConfigsService.buscarChatbotConfigs().subscribe(
        response => {
          this.loading = false;
          this.chatbotConfigs = response.data;
        },
        errorResponse => {
          this.loading = false;
          this.messageService.add({ severity: 'error', summary: 'Erro', detail: errorResponse.error.mensagem });
        }
      )
    );
  }

  salvarChatbot() {
    this.loading = true;
    this.subs.push(
      this.adminConfigsService.salvarChatbotConfigs(this.chatbotConfigs).subscribe(
        response => {
          this.loading = false;
          this.messageService.add({ severity: 'success', summary: this.msgTitulo, detail: this.msgSucesso });
        },
        errorResponse => {
          this.loading = false;
          this.listErrors = errorResponse.error.errors;
          this.messageService.add({ severity: 'error', summary: 'Erro', detail: errorResponse.error.mensagem });
        }
      )
    );
  }

  buscarTokenGTOConfigs() {
    this.loading = true;
    this.subs.push(
      this.adminConfigsService.buscarTokenGTOConfigs().subscribe(
        response => {
          this.loading = false;
          this.tokenGTOConfigs = response.data;
        },
        errorResponse => {
          this.loading = false;
          this.messageService.add({ severity: 'error', summary: 'Erro', detail: errorResponse.error.mensagem });
        }
      )
    );
  }

  salvarTokenGTOConfigs() {
    this.loading = true;
    this.subs.push(
      this.adminConfigsService.salvarTokenGTOConfigs(this.tokenGTOConfigs).subscribe(
        response => {
          this.loading = false;
          this.messageService.add({ severity: 'success', summary: this.msgTitulo, detail: this.msgSucesso });
        },
        errorResponse => {
          this.loading = false;
          this.listErrors = errorResponse.error.errors;
          this.messageService.add({ severity: 'error', summary: 'Erro', detail: errorResponse.error.mensagem });
        }
      )
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/configs/admin-configs.component.ts